/* global axios */

import ApiClient from './ApiClient';

class Agents extends ApiClient {
  constructor() {
    super('agents', { accountScoped: true });
  }

  bulkInvite({ emails }) {
    return axios.post(`${this.url}/bulk_create`, {
      emails,
    });
  }

  assignSeats({ keepUserIds }) {
    return axios.put(`${this.baseUrl()}/agent_seats`, {
      keep_user_ids: keepUserIds,
    });
  }
}

export default new Agents();
